import { render, staticRenderFns } from "./ClientsSelector.vue?vue&type=template&id=764bf184"
import script from "./ClientsSelector.vue?vue&type=script&lang=js"
export * from "./ClientsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports